<template>
  <div class="input-upload">
    <v-text-field
      v-model="getFile"
      :label="label"
      prepend-icon="mdi-paperclip"
      :required="required"
      :error="hasError"
      :error-messages="sizeLimit"
      :loading="loading"
      :rules="rules"
      readonly
      outlined
      clearable
      @click.native="pickFile()"
      @blur="emit($event)"
    >
      <template v-slot:prepend-inner>
        <v-chip
          v-if="getFile && getFile.name"
          color="backgroundPrimary500 accent-4 bold"
          dark
          label
          small
        >
          {{ getFile.name }}
        </v-chip>
      </template>
    </v-text-field>
    <input
      ref="image"
      :accept="accept"
      style="display: none"
      type="file"
      @change="onFilePicked($event)"
    >
  </div>
</template>

<script>

export default {
  name: 'InputUpload',
  components: {
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: '',
          file: '',
          rawFile: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    required: {
      type: Boolean,
    },
    maxSizeInMb: {
      type: Number,
      default: 2,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    sizeLimit: '',
    hasError: false,
  }),
  computed: {
    getFile: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    emit() {
      return (ev) => {
        this.$emit('blur', ev);
      };
    },
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const { files } = e.target;
      this.getFile.name = '';
      this.getFile.file = '';

      if (files[0] !== undefined) {
        const fileSize = files[0].size / 1024 / 1024;
        if (fileSize > this.maxSizeInMb) {
          this.hasError = true;
          this.sizeLimit = `Tamanho máximo é de ${this.maxSizeInMb}MB`;
          return;
        }
        this.hasError = false;
        this.sizeLimit = '';
        if (files[0].name.lastIndexOf('.') <= 0) {
          this.getFile.name = files[0].name;
          this.getFile.rawFile = files;
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', /* istanbul ignore next */ () => {
          this.getFile.file = fr.result;
          this.getFile.name = files[0].name;
          this.getFile.rawFile = files;
        });
      }
    },
  },
};
</script>
<style>
.input-upload .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot input {
  display: none !important;
}

.input-upload .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  position: absolute !important;
  left: 20% !important;
  width: 100% !important;
}

.input-upload  label.v-label.theme--light {
  left: -17% !important;
}
</style>
